import { http } from '@/http/axios.js';

export function getDayListAPI(params) {
  return http({
    url: '/adminapi/bi/channel/day/page',
    method: 'get',
    params
  })
}

export function getMonthListAPI(params) {
  return http({
    url: '/adminapi/bi/channel/month/page',
    method: 'get',
    params
  })
}
